<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="0">
        <div class="pa-3">
          <h2 style="font-size: 30px">
            <div class="grid_half pa-4 mb-8">
              <div class="grid_flex justify-start">
                <!-- <div class="mr-1 mt-1">ปี พ.ศ.</div> -->
                <!-- <div class="mr-1 green--text" style="font-size: 35px">{{ new Date().getFullYear()+543 }}</div> -->
                <div class="">
                  <v-select color="#86bc3a" @input="get_data()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year_member" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
                </div>
              </div>
              <div class="grid_flex justify-end">
                <div class="mr-1 mt-1">เดรดิต/Credit :</div>
                <div class="mr-1 green--text" style="font-size: 35px">{{ total }} <span class="black--text">฿</span></div>
              </div>
            </div>
          </h2>
          <div class="grid_list mt-3">
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ january.month_name }}</div>
              <div class="font_money">฿ {{ january.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(january.month, january.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ february.month_name }}</div>
              <div class="font_money">฿ {{ february.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(february.month, february.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ march.month_name }}</div>
              <div class="font_money">฿ {{ march.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(march.month, march.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ april.month_name }}</div>
              <div class="font_money">฿ {{ april.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(april.month, april.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ may.month_name }}</div>
              <div class="font_money">฿ {{ may.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(may.month, may.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ june.month_name }}</div>
              <div class="font_money">฿ {{ june.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(june.month, june.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ july.month_name }}</div>
              <div class="font_money">฿ {{ july.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(july.month, july.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ august.month_name }}</div>
              <div class="font_money">฿ {{ august.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(august.month, august.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ september.month_name }}</div>
              <div class="font_money">฿ {{ september.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(september.month, september.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ october.month_name }}</div>
              <div class="font_money">฿ {{ october.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(october.month, october.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ november.month_name }}</div>
              <div class="font_money">฿ {{ november.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(november.month, november.year)">ดูรายละเอียด</v-btn>
            </v-card>
            <v-card elevation="6" class="text-center pa-3 mx-1">
              <div class="font_month">{{ december.month_name }}</div>
              <div class="font_money">฿ {{ december.sum }}</div><br>
              <v-btn height="50" width="100%" class="white--text" color="#8cc63e" @click="get_detail(december.month, december.year)">ดูรายละเอียด</v-btn>
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      loading_page: false,
      january: [],
      february: [],
      march: [],
      april : [],
      may: [],
      june: [],
      july: [],
      august: [],
      september: [],
      october: [],
      november: [],
      december: [],
      total: 0,
      year_arr: [],
      selected_year_member: null,
      year: [
        {id: 1, name: 'ปี 2565'},
        {id: 2, name: 'ปี 2564'},
        {id: 3, name: 'ปี 2563'},
        {id: 4, name: 'ปี 2562'},
        {id: 5, name: 'ปี 2561'},
      ],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_year_member = this.year_arr[0].year_eng
      await this.get_data()
    },
    async get_data() {
      this.loading_page = true
      await HTTP.post('creditor/showcreditor', {
        year: this.selected_year_member,
      }).then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.january = res.data.object.january
              this.february = res.data.object.february
              this.march = res.data.object.march
              this.april = res.data.object.april
              this.may = res.data.object.may
              this.june = res.data.object.june
              this.july = res.data.object.july
              this.august = res.data.object.august
              this.september = res.data.object.september
              this.october = res.data.object.october
              this.november = res.data.object.november
              this.december = res.data.object.december
              this.total = res.data.object.sum
            }
          })
    },
    get_detail(month, year) {
      this.$router.push('/creditor/pumain/' + month + '/' + year)
    },
  },
  mounted() {
    this.get_data()
    this.year_function()
  
  }
}
</script>

<style scoped>
.grid_list {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
  grid-gap: 15px 0;
}

.font_month {
  color: #7c807d;
  font-size: 25px;
  text-align: left;
}

.font_money {
  font-size: 35px;
  /*color: #4CAF50 !important;*/
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
@media only screen and (max-width: 1100px) {
  .grid_list{
    grid-template-columns: 33.3% 33.3% 33.3%;
  }
}
@media only screen and (max-width: 1000px) {
  .grid_list{
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 750px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 500px) {
  .grid_list{
    grid-template-columns: 100%;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
    text-align: center;
  }
}
</style>
